export const FETCH_ALL_INSTITUTIONS = 'FETCH_ALL_INSTITUTIONS'
export const FETCH_INSTITUTION = 'FETCH_INSTITUTION'